<div class="provision-section">

  <!-- Existing provision entries -->
  <table class="table table-compact" *ngIf="warehouse.length > 0">
    <thead>
      <tr>
        <th class="left">Art</th>
        <th class="left">Eigentümer</th>
        <th class="left">Datum</th>
        <th class="right">Anzahl</th>
        <th class="left">Seriennummer</th>
        <th class="left">Charge</th>
        <th class="left">Erfasst von</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let w of warehouse">
        <td class="left"><span [ngClass]="movementClass(w.movement_type)">{{ movementLabel(w.movement_type) }}</span></td>
        <td class="left">{{ w.provision_owner === 'internal' ? 'Intern (eigenes Lager)' : (w.provision_owner || '—') }}</td>
        <td class="left">{{ w.date | date:'dd.MM.yyyy' }}</td>
        <td class="right"><b [ngClass]="pieceClass(w.movement_type)">{{ pieceSign(w.movement_type) }}{{ w.number_of_pieces }}</b></td>
        <td class="left">{{ w.serial_nr || '—' }}</td>
        <td class="left">{{ w.heat_nr || '—' }}</td>
        <td class="left">{{ w.firstname }} {{ w.lastname }}</td>
        <td class="action-cell">
          <cds-icon shape="times-circle" class="is-solid icon-delete" (click)="delete(w.id)"></cds-icon>
        </td>
      </tr>
    </tbody>
  </table>

  <p *ngIf="!loading && warehouse.length === 0" class="empty-hint">Keine Beistellungen für diese Position.</p>

  <!-- New provision form -->
  <div class="provision-form" *ngIf="showForm">
    <form [formGroup]="provisionForm" class="clr-form clr-form-compact">
      <div class="form-row">

        <clr-select-container>
          <label>Art</label>
          <select clrSelect formControlName="movement_type">
            <option value="provision_in">Beistellung Eingang</option>
            <option value="provision_out">Beistellung Ausgang</option>
          </select>
        </clr-select-container>

        <clr-select-container>
          <label>Eigentümer</label>
          <select clrSelect formControlName="provision_owner">
            <option value="internal">Intern (eigenes Lager)</option>
            <option *ngFor="let c of customers" [value]="c.cid.toString()">{{ c.company }}</option>
          </select>
        </clr-select-container>

        <clr-date-container>
          <label>Datum</label>
          <input type="date" clrDate formControlName="date" />
        </clr-date-container>

        <clr-input-container>
          <label>Anzahl</label>
          <input type="number" clrInput min="0" formControlName="number_of_pieces" />
        </clr-input-container>

        <clr-input-container>
          <label>Seriennummer</label>
          <input type="text" clrInput placeholder="optional" formControlName="serial_nr" />
        </clr-input-container>

        <clr-input-container>
          <label>Charge</label>
          <input type="text" clrInput placeholder="optional" formControlName="heat_nr" />
        </clr-input-container>

        <clr-input-container>
          <label>Kommentar</label>
          <input type="text" clrInput placeholder="optional" formControlName="comment" />
        </clr-input-container>

      </div>
    </form>
  </div>

  <!-- Actions -->
  <div class="provision-actions">
    <button *ngIf="!showForm" class="btn btn-sm btn-primary" (click)="showForm = true">
      <cds-icon shape="plus-circle"></cds-icon> Beistellung erfassen
    </button>
    <ng-container *ngIf="showForm">
      <button class="btn btn-sm btn-success" (click)="save()">
        <cds-icon shape="check-circle"></cds-icon> Speichern
      </button>
      <button class="btn btn-sm btn-link" (click)="showForm = false; initForm()">Abbrechen</button>
    </ng-container>
  </div>

</div>

<clr-modal *ngIf="showPdf" [(clrModalOpen)]="showPdf" [clrModalStaticBackdrop]="false">
  <h3 class="modal-title">{{ modalContent }}</h3>
  <div class="modal-body">
    <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
  </div>
</clr-modal>
